import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeWords',
})
export class CapitalizeWordsPipe implements PipeTransform {
  transform(value: string): unknown {
    return value
      .toLowerCase()
      .split(' ')
      .map((w) => w[0].toUpperCase() + w.slice(1))
      .join(' ');
  }
}
